/**
 * Created by Angelika on 05.09.2017.
 */
import * as actionTypes from '../constants/actionTypes';

export function resetVideo() {
    return {type: actionTypes.RESET_STATE_VIDEO};
}

export function play() {
    return {type: actionTypes.PLAY_VIDEO};
}

export function pause() {
    return {type: actionTypes.PAUSE_VIDEO};
}

export function mute() {
    return {type: actionTypes.MUTE_VIDEO};
}

export function changeVolume(v) {
    return {type: actionTypes.CHANGE_VOLUME_VIDEO, volume: v};
}

export function changeQuality(q) {
    return {type: actionTypes.CHANGE_QUALITY_VIDEO, quality: q};
}

export function expand() {
    return {type: actionTypes.EXPAND_VIDEO};
}

export function collapse() {
    return {type: actionTypes.COLLAPSE_VIDEO};
}

export function setHlsLevels(levels) {
    return {type: actionTypes.SET_HLS_LEVELS, levels: levels};
}

export function setHlsCurrentLevel(current) {
    return {type: actionTypes.SET_HLS_LEVEL_CURRENT, current: current};
}

export function setError(error_title, error_description) {
    return {type: actionTypes.SET_ERROR_VIDEO, error_title: error_title, error_description: error_description};
}


// WEBPACK FOOTER //
// ./src/actions/video.js